module.exports = __webpack_public_path__ + "img/polyduim.e9a62685.png";